import React, { lazy, memo } from 'react';
import { motion } from 'framer-motion';
const methods = [{
  image: 'https://cdn.magicpatterns.com/uploads/1vPHN81VjnQ3DSEKicfR7P/ChatGPT_Image_11_jun_2026,_04_36_05.webp',
  tomo: 'Tomo 3 · Silabeo',
  title: 'El Método de Bloques',
  color: 'bg-slate-50 border-slate-100',
  desc: 'Cómo enseñarle al cerebro a leer grupos de palabras en vez de letras sueltas. Tu hijo entiende visualmente por qué leer de una sola vez es más fácil, sin memorizar reglas vacías.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/kw8M3thPVMMSzezrZNBEiQ/ChatGPT_Image_11_jun_2026,_04_39_35.webp',
  tomo: 'Tomo 2 · Entrenamiento Ocular',
  title: 'El Deslizador Mágico',
  color: 'bg-amber-50 border-amber-100',
  desc: 'Un sistema visual para que los ojos dejen de saltar y sigan el renglón de forma fluida. Ideal para niños que pierden el lugar o usan el dedo como muleta.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/34rKyFynwJFwgEfEWexwTE/ChatGPT_Image_11_jun_2026,_04_42_17.webp',
  tomo: 'Tomo 4 · Comprensión',
  title: 'El Cine Mental',
  color: 'bg-emerald-50/50 border-emerald-100',
  desc: 'Con una técnica simple de visualización activa, tu hijo construye una película mental mientras lee, logrando que la comprensión ocurra de forma natural.'
}];
export function VisualMethods() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-335">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-336">
        <div className="text-center mb-8" data-id="element-337">
          <span className="text-gold font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-338">
            Mirá adentro del sistema
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-navy" data-id="element-339">
            Un vistazo a los Métodos Visuales
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-340">
            Herramientas reales que tu hijo puede ver, tocar y entender en
            minutos.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-341">
          {methods.map((m, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`rounded-2xl border ${m.color} flex flex-col overflow-hidden`} data-id="element-342">
              <div className="p-3 pb-0" data-id="element-343">
                <div className="rounded-xl overflow-hidden bg-white border border-slate-100 shadow-sm" data-id="element-344">
                  <img src={m.image} alt={`${m.title} — método visual`} width={1240} height={1240} className="w-full h-auto block" loading="lazy" decoding="async" data-id="element-345" />
                </div>
              </div>
              <div className="p-6 pt-5 flex flex-col flex-1" data-id="element-346">
                <div className="text-xs font-bold text-slate-500 uppercase tracking-wide mb-1.5" data-id="element-347">
                  {m.tomo}
                </div>
                <h3 className="text-xl font-bold text-navy mb-3" data-id="element-348">{m.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-349">
                  {m.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}